<mat-spinner></mat-spinner>

<h3 *ngIf="state === 'auth'" class="mat-h3" translate>
    SissCloudWaitingForAuthentication
</h3>

<h3 *ngIf="state === 'upload'" class="mat-h3" translate>
    SissCloudUploadingDocuments
</h3>
